import { render, staticRenderFns } from "./AboutProject.vue?vue&type=template&id=c1cc3606"
import script from "./AboutProject.vue?vue&type=script&lang=ts"
export * from "./AboutProject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports